module.exports = __webpack_public_path__ + "82958ae7c79d6f93290bf6f4e2d733b3.png";